
import { NewsService } from '@/services/news.service'

const state = {
    dialog: false,
    loading: false,
    show: false,
    type: null,
    message: null,
    dialogutama: false,
    colordialog: 'indigo',
    judul: '',
    color: '',
    newslist: []
};

const actions = {
    OpenDialogForm({ commit }) {
        commit('opendialog');
    },
    closeDialog({ commit }) {
        commit('closedialog');
    },
    getNews({ commit }) {
        commit('setloading', true);
        NewsService.NewsList().then(data => {
            //console.log(data.data[0]);
            commit('addResponseApp', data);
        }, error => {
            console.log(error);
        });
    },
    DeleteNews({ dispatch, commit }, delete_id) {
        NewsService.deleteNews(delete_id).then(data => {
            dispatch('alert/success', 'Delete data Successfully', { root: true });
            commit('ShowAdd', data);
            NewsService.NewsList().then(data => {
                //console.log(data.data[0]);
                commit('addResponseApp', data);
            }, error => {
                console.log(error);
            });
        }, error => {
            dispatch('alert/error', error, { root: true });
        })
    },
    AddNews({ dispatch, commit }, newData) {
        commit('setloading', true);
        NewsService.AddNews(newData)
            .then(data => {
                dispatch('alert/success', data.msg, { root: true });
                commit('ShowAdd', data);
                NewsService.NewsList().then(data => {
                    commit('addResponseApp', data);
                }, error => {
                    console.log(error);
                });
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    },
    EditNews({ dispatch, commit }, editdata) {
        NewsService.EditNews(editdata)
            .then(data => {
                dispatch('alert/success', 'Edit data Successfully', { root: true });
                commit('ShowAdd', data);
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    }
}


const mutations = {
    ShowAdd(state, data) {
        console.log(data);
        state.dialog = false;
        state.loading = false;
    },
    setloading(state, data) {
        state.loading = data;
    },
    addResponseApp(state, apps) {
        state.newslist = []
        state.newslist = apps.data.content;
        state.loading = false;
        //console.log(state.applist[0]);
    },
    opendialog(state) {
        state.dialog = true
    },
    closedialog(state) {
        state.dialog = false
    }
}


export const news = {
    namespaced: true,
    state,
    actions,
    mutations
};
